import React from "react";
import Swal from "sweetalert2";
import api from "./../../Api.js";
import moment from "moment";
import {
  Modal,
  Card,
  CardHeader,
  Row,
  Col,
  Button,
  Table,
  UncontrolledTooltip,
  Container,
  Badge,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Input
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { connect } from "react-redux";
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import EditUserQRcode from "./modal/users/EditUserQRcode.jsx";
import EditUser from "./modal/users/EditUser.jsx";
import EditUserCardQRCode from "./modal/users/EditUserCardQRCode.jsx";
import ImportXlsxUser from "./modal/users/ImportXlsxUser.jsx";
import BulkUpdateUsersXlsx from "./modal/users/BulkUpdateUsersXlsx.jsx";
import SmartExcelConverter from "./modal/users/SmartExcelConverter.jsx";
import reduxHelper from "./../../helper/index.js";
import AlterUserPassword from "./modal/users/AlterUserPassword.jsx";
import $ from "jquery";
import { ClipLoader } from "react-spinners";
import * as JSZip from "jszip";
import UserLogs from "./modal/users/UserLogs.jsx";
import UserEditHistory from "./modal/users/UserEditHistory.jsx";
import CourseHistoryModal from "./modal/users/CourseHistoryModal.jsx";
import ModalUserClassrooms from "./modal/users/ModalUserClassrooms.jsx";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.removerUser = this.removerUser.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.editUser = this.editUser.bind(this);
    this.putUser = this.putUser.bind(this);
    this.newUser = this.newUser.bind(this);
    this.removeUserApi = this.removeUserApi.bind(this);
    this.editQRcodeUser = this.editQRcodeUser.bind(this);
    this.handleQrError = this.handleQrError.bind(this);
    this.handleQrScan = this.handleQrScan.bind(this);
    this.newImport = this.newImport.bind(this);
    this.openBulkUpdateModal = this.openBulkUpdateModal.bind(this);
    this.helper = new reduxHelper(this.props);
    this.getAllUsers = this.getAllUsers.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.checkUser = this.checkUser.bind(this);
    this.generateQr = this.generateQr.bind(this);
    this.fetchUserClassrooms = this.fetchUserClassrooms.bind(this);
    this.openClassroomModal = this.openClassroomModal.bind(this);
    this.closeClassroomModal = this.closeClassroomModal.bind(this);
    this.toggleConfirmReportModal = this.toggleConfirmReportModal.bind(this);
    this.confirmGenerateReport = this.confirmGenerateReport.bind(this);
    this.exportAlunos = this.exportAlunos.bind(this);
    this.toggleShowBlocked = this.toggleShowBlocked.bind(this);
    this.postUser = this.postUser.bind(this);
    this.openPadronizarModal = this.openPadronizarModal.bind(this);
    this.closePadronizarModal = this.closePadronizarModal.bind(this);
    this.executarPadronizacao = this.executarPadronizacao.bind(this);

    this.state = {
      loadUser: false,
      openModalalterUserPassword: false,
      openModalImport: false,
      openModalBulkUpdateUsers: false,
      openSmartConverter: false,
      loadComplete: false,
      openDialogUserCreate: false,
      openLanguageDialog: false,
      openDialogRemoveUser: false,
      showPassword: false,
      textDialog: "",
      descriptionDialog: "",
      FormHelperTextPassword: "",
      loading: false,
      userError: "",
      users: [],
      filteredUsers: [],
      levelAcess: [],
      language: [],
      userEdit: "",
      dialog: {
        name: "",
        lastName: "",
        email: "",
        birthDate: "",
        blocked: "",
        blockedReason: "",
        genre: "1"
      },
      qrcode: { setar: false, saveSet: false },
      company: this.props.user.preference.selectcompany,
      showRest: false,
      openUserLogs: false,
      userLogsId: null,
      userLogsName: "",
      openUserEditHistory: false,
      userEditHistoryId: null,
      userEditHistoryName: "",
      userClassrooms: {},
      classroomModalOpen: false,
      classroomModalUserId: null,
      openCourseHistory: false,
      courseHistoryUserId: null,
      courseHistoryUserName: "",
      courseHistory: {},
      showConfirmReportModal: false,
      exportAlunosLoading: false,
      companyName: "",
      showBlocked: false,
      openPadronizarModal: false,
      padronizarUsernamePattern: "nome.sobrenome",
      padronizarPasswordOption: "data_nascimento",
      padronizarPasswordFixa: "",
      padronizarProgress: null,
      padronizarError: ""
    };

    window.listUsers = this;
  }

  // Buscando todos os usuários via API e, por padrão, filtrando apenas ativos
  async getAllUsers() {
    await this.setState({ company: this.props.user.preference.selectcompany });
    await api
      .usersCompany(this.props.user.preference.selectcompany)
      .then(res => {
        const all = res.data;
        this.setState({
          users: all,
          // inicialmente, mostra apenas usuários não bloqueados
          filteredUsers: all.filter(u => parseInt(u.blocked, 10) === 0),
          loadUser: true,
          showBlocked: false
        });
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);
      });
        //   await this.setState({company:this.props.user.preference.selectcompany});

  //   await api.userCompany(this.props.user.preference.selectcompany).then((res) => {
  //     this.setStat({
  //       users: res.data,
  //       filteredeUsers: res.data.filter(u => parseInt(u.blocked) === 0),
  //       loadUser: true,
  //       showBlocked: false
  //     })
  //   }).catch(error => {
  //       console.log(error.data);
  //       console.log(error);
  //       console.log(error.response);
  //   })
  }
  
  async fetchUserClassrooms(userId) {
    try {
      const res = await api.getUserClassrooms(userId);
      this.setState(s => ({
        userClassrooms: {
          ...s.userClassrooms,
          [userId]: res.data
        }
      }));
    } catch (err) {
      console.error(err);
    }
  }

  openClassroomModal(userId) {
    this.setState({
      classroomModalOpen: true,
      classroomModalUserId: userId
    });
    this.fetchUserClassrooms(userId);
  }

  closeClassroomModal() {
    this.setState({
      classroomModalOpen: false,
      classroomModalUserId: null
    });
  }

  toggleConfirmReportModal() {
    this.setState(s => ({ showConfirmReportModal: !s.showConfirmReportModal }));
  }

  openCourseHistory(userId) {
    if (!userId) return;
    const user = this.state.users.find(u => parseInt(u.id, 10) === parseInt(userId, 10));
    if (!user) return;

    this.setState({
      openCourseHistory: true,
      courseHistoryUserId: userId,
      courseHistoryUserName: `${user.name} ${user.lastName}`,
      courseHistory: null
    });

    api
      .getUserCourseHistory(userId)
      .then(res => this.setState({ courseHistory: res.data }))
      .catch(() => this.setState({ courseHistory: {} }));
  }

  closeCourseHistory() {
    this.setState({
      openCourseHistory: false,
      courseHistoryUserId: null,
      courseHistoryUserName: "",
      courseHistory: {}
    });
  }

  async getAllLevelAcess() {
    await api
      .levelAcess()
      .then(res => {
        this.setState({ levelAcess: res.data });
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);
      });
  }

  async listLanguages() {
    await api
      .listLanguages()
      .then(res => {
        this.setState({ language: res.data });
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);
      });
  }

  async putUser() {
    let data = JSON.parse(JSON.stringify(this.state.dialog));
    data.birthDate = moment(data.birthDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    data.company = this.props.user.preference.selectcompany;
    data.genre = window.$("#sexo").val();
    data.accessLevel = window.$("#nivelAcesso").val();
    data.blocked = window.$("#bloquearAcesso").val();
    data.blockedQRcode = window.$("#bloquearAcessoQRcode").val();

    data.state = data.state || " ";
    data.city = data.city || " ";
    data.tel = data.tel || " ";

    await api
      .updateUser(this.state.userEdit, data)
      .then(res => {
        this.setState({ openDialogUserCreate: false, loading: false });

        // Atualiza usuário na lista local
        const updatedUser = res.data.user;
        const users = [...this.state.users].map(u =>
          parseInt(u.id) === parseInt(updatedUser.id) ? updatedUser : u
        );
        this.setState({ users });

        let options = {
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">
                {this.props.translate["as_alteracoes_foram_salvas"]}
              </span>
              <span data-notify="message">
                {this.props.translate["informe_para_relogar_no_sistema"]}
              </span>
            </div>
          ),
          type: "success",
          icon: "ni ni-check-bold",
          autoDismiss: 7
        };
        this.refs.notificationAlert.notificationAlert(options);
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        const status = error.response?.status;
        const msg = error.response?.data?.msg || "Erro ao editar usuário.";

        // trata 400 e 403 como erro de formulário no modal
        if (status === 400 || status === 403) {
          this.setState({ userError: msg });
        } else {
          let options = {
            place: "tr",
            message: (
              <div className="alert-text">
                <span className="alert-title">Erro!</span>
                <span data-notify="message">{msg}</span>
              </div>
            ),
            type: "danger",
            icon: "ni ni-bell-55",
            autoDismiss: 7
          };
          this.refs.notificationAlert.notificationAlert(options);
        }
      });
  }

  async postUser(importxlx, data) {
    if (data === undefined) {
      data = JSON.parse(JSON.stringify(this.state.dialog));
      data.birthDate = moment(data.birthDate, "DD/MM/YYYY").format("YYYY-MM-DD");
      data.accessLevel = window.$("#nivelAcesso").val();
      data.genre = window.$("#sexo").val();
      data.blocked = window.$("#bloquearAcesso").val();
      data.blockedQRcode = window.$("#bloquearAcessoQRcode").val();
      data.state = data.state || " ";
      data.city = data.city || " ";
      data.tel = data.tel || " ";
    }

    data.company = this.props.user.preference.selectcompany;

    var post = await api
      .postUser(data)
      .then(res => {
        if (importxlx === undefined) {
          this.setState({ openDialogUserCreate: false, loading: false });
          this.getAllUsers();
          let options = {
            place: "tr",
            message: (
              <div className="alert-text">
                <span className="alert-title" data-notify="title">
                  {this.props.translate["usuario_cadastrado_com_sucesso"]}
                </span>
              </div>
            ),
            type: "success",
            icon: "ni ni-check-bold",
            autoDismiss: 7
          };
          this.refs.notificationAlert.notificationAlert(options);
        }
        return res.data;
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);

        this.setState({ loading: false });
        if (error.response.status === 400) {
          this.setState({ userError: "" });
          this.setState({ userError: error.response.data.msg });
        }
        return false;
      });
    return post;
  }

  editUser(id) {
    this.setState({
      userError: "",
      userEdit: id,
      openDialogUserCreate: true,
      textDialog: this.props.translate["editar_usuario"],
      descriptionDialog: "",
      showPassword: false,
      FormHelperTextPassword: this.props.translate["deixe_em_branco_para_nao_alterar"]
    });
    this.state.users.forEach(function(item) {
      if (parseInt(item.id) === parseInt(id)) {
        var item2 = JSON.stringify(item);
        item2 = JSON.parse(item2);
        delete item2.createDate;
        delete item2.updateDate;
        delete item2.lastAcess;
        delete item2.qrcodePassword;
        delete item2.id;
        delete item2.preference;
        delete item2.photo;
        item2.birthDate = moment(item2.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY");
        this.setState({ dialog: item2 });
      }
    }, this);
  }

  newUser() {
    this.setState({
      dialog: {
        verify: "1",
        state: "",
        city: "",
        tel: "",
        name: "",
        lastName: "",
        email: "",
        accessLevel: "",
        birthDate: "",
        blocked: "0",
        blockedReason: "",
        blockedQRcode: "0"
      },
      FormHelperTextPassword: "",
      userError: "",
      userEdit: "",
      openDialogUserCreate: true,
      textDialog: this.props.translate["cadastrar_usuario"],
      descriptionDialog: "",
      showPassword: false
    });
  }

  saveUser(e) {
    e.preventDefault();
    this.setState({ loading: true });
    if (this.state.userEdit === "") {
      this.postUser();
    } else {
      this.putUser();
    }
  }

  removerUser(id) {
    this.setState({ openDialogRemoveUser: true, userDeletion: id });
  }

  async getAllclassRoom() {
    await api
      .getAllClassRoomCompany(this.props.user.preference.selectcompany)
      .then(res => {
        res.data.reverse();
        this.setState({ classRoom: res.data });
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);
        if (error.response !== undefined) {
          if (error.response.status !== undefined) {
            if (error.response.status === 401) {
              let options = {
                place: "tr",
                message: (
                  <div className="alert-text">
                    <span className="alert-title" data-notify="title">
                      Ops!
                    </span>
                    <span data-notify="message">{error.response.data.msg}</span>
                  </div>
                ),
                type: "danger",
                icon: "fas fa-exclamation",
                autoDismiss: 7
              };
              this.refs.notificationAlert.notificationAlert(options);
            }
          }
        }
      });
  }

  async removeUserApi() {
  this.setState({ openDialogRemoveUser: false, loading: true });
  const id = parseInt(this.state.userDeletion, 10);

    try {
      await api.deleteUser(id);

      const users = this.state.users.filter(u => u.id !== id);
      const filteredUsers = this.state.showBlocked
        ? users
        : users.filter(u => parseInt(u.blocked, 10) === 0);

      this.setState({ users, filteredUsers, loading: false });

      const opts = {
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["sucesso"]}!</span>
            <span data-notify="message">{this.props.translate["usuario_removido"]}</span>
          </div>
        ),
        type: "success",
        icon: "ni ni-check-bold",
        autoDismiss: 7
      };
      this.refs.notificationAlert.notificationAlert(opts);

    } catch (error) {
      console.error("Erro ao remover usuário", id, error);
      this.setState({ loading: false });
      const msg = error.response?.data?.msg || "Erro ao remover o usuário.";
      const opts = {
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["erro"]}</span>
            <span data-notify="message">{msg || this.props.translate["erro_ao_remover_usuario"]}</span>
          </div>
        ),
        type: "danger",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      };
      this.refs.notificationAlert.notificationAlert(opts);
    }
  }

  async componentDidUpdate() {
    if (this.state.company !== this.props.user.preference.selectcompany) {
      await this.getAllUsers();
      await this.getAllclassRoom();
    }
  }

  async componentDidMount() {
    if (this.props.user.preference.selectcompany !== "") {
      // busca o nome da companhia selecionada
      const cid = this.props.user.preference.selectcompany;
      try {
        const res = await api.getCompany(cid);
        this.setState({ companyName: res.data.name });
      } catch (e) {
        console.error("erro ao buscar nome da companhia", e);
      }

      await this.getAllclassRoom();
      await this.listLanguages();
      await this.getAllUsers();
      await this.getAllLevelAcess();
    }

    this.setState({ loadComplete: true });
  }

  selectLanguage(id) {
    var dialog = this.state.dialog;
    dialog.language = id;
    this.setState({ openLanguageDialog: false, dialog: dialog });
  }

  async editQRcodeUser(id, modal) {
    if (modal === undefined) {
      modal = true;
    }

    var index = this.state.users.map(x => x.id).indexOf(parseInt(id));
    if (index === -1) {
      return false;
    }

    var user = this.state.users[index];
    delete window.resetQR;
    this.setState({ openModalQRcode: modal, editUser: user.id, qrcodePassword: undefined });

    // Para pegar o QR code do usuário
    await api
      .getQrCodeUser(user.id)
      .then(async res => {
        var qrcode = this.state.qrcode;
        qrcode.qrcodePassword = res.data.qrcodePassword;
        qrcode.name = user.name + " " + user.lastName;
        qrcode.username = user.username;
        await this.setState({ qrcode });
        return true;
      })
      .catch(error => {
        return false;
      });
  }

  donwloadSVGQRCODE() {
    window.$("#figureSvg")
      .find("svg")
      .attr("xmlns", "http://www.w3.org/2000/svg");
    var svgData = window.$("#figureSvg").html();
    var svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    var svgUrl = URL.createObjectURL(svgBlob);

    var downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = this.state.qrcode.name + " QR CODE.svg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  handleQrError(e) {
    console.log(e);
  }

  async handleQrScan(password) {
    if (password === null || password === "") {
      return false;
    }

    var obj = { qrcode: password };
    await api
      .setQRcode(this.state.editUser, obj)
      .then(res => {
        var qr = this.state.qrcode;
        qr.setar = false;
        qr.qrcodePassword = password;
        this.setState({ qrcode: qr });

        let options = {
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">
                {this.props.translate["qr_code_atualizado"]}
              </span>
            </div>
          ),
          type: "success",
          icon: "ni ni-check-bold",
          autoDismiss: 7
        };
        this.refs.notificationAlert.notificationAlert(options);

        var users = this.state.users;
        for (var i = 0; i < users.length; i++) {
          if (parseInt(users[i].id) === parseInt(this.state.editUser)) {
            users[i].qrcodePassword = password;
          }
        }
        this.setState({ users: users });
      })
      .catch(error => {
        console.log(error.data);
        console.log(error);
        console.log(error.response);
        if (error.response.status === 400) {
          if (window.$(".alert-text").length !== 0) {
            return false;
          }
          let options = {
            place: "tr",
            message: (
              <div className="alert-text">
                <span className="alert-title" data-notify="title">
                  {error.response.data.msg}
                </span>
              </div>
            ),
            type: "danger",
            icon: "ni ni-check-bold",
            autoDismiss: 7
          };
          this.refs.notificationAlert.notificationAlert(options);
        }
      });
  }

  newImport() {
    this.setState({ openModalImport: true });
  }

  openBulkUpdateModal() {
    this.setState({ openModalBulkUpdateUsers: true });
  }

  checkAll() {
    var check = $("#_check").is(":checked");
    if (check === false) {
      $(".user_check").prop("checked", false);
    } else {
      $(".user_check").prop("checked", true);
    }
    this.setState({ a: "a" });
  }

  checkUser() {
    this.setState({ a: "a" });
    if ($(".user_check:checked").length === $(".user_check").length) {
      $("#_check").prop("checked", true);
    } else {
      $("#_check").prop("checked", false);
    }
    if ($(".user_check:checked").length === 0) {
      $("#_check").prop("checked", false);
    }
  }

  // Retorna os IDs dos usuários selecionados (checkbox marcados)
  getSelectedUserIds() {
    return $(".user_check:checked")
      .map(function () { return parseInt($(this).attr("idc"), 10); })
      .get();
  }

  // Retorna os objetos dos usuários selecionados
  getSelectedUsers() {
    const ids = new Set(this.getSelectedUserIds());
    return this.state.users.filter(u => ids.has(parseInt(u.id, 10)));
  }

  async generateQr() {
    if (this.state.generateQRCodes === true) {
      return false;
    }
    this.setState({ generateQRCodes: true, qrcodeprogress: 0 });

    var zip = new JSZip();
    var img = zip.folder("Cards");
    var frente = await window.edituserqrcode.gera_card(true);
    frente.href = frente.href.replace("data:image/png;base64,", "");
    zip.file("Frete do cartao.png", frente.href, { base64: true });

    var users = [];
    $(".user_check:checked").each(async function() {
      users.push($(this).attr("idc"));
    });

    for (let index = 0; index < users.length; index++) {
      var gerou = await this.editQRcodeUser(users[index], false);
      if (gerou === false) {
        this.setState({ generateQRCodes: false });
        alert("Não foi possível gerar o QR code do usuário " + users[index] + " ");
        return false;
      }
      var base = await window.edituserqrcode.gera_card_2(true);
      base.href = base.href.replace("data:image/png;base64,", "");
      img.file(base.download, base.href, { base64: true });

      var calc = ((index + 1) * 100) / users.length;
      this.setState({ qrcodeprogress: calc.toFixed(0) });
    }

    zip.generateAsync({ type: "blob" }).then(function(content) {
      var data = new Blob([content], { type: "application/zip" });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "QR codes.zip");
      tempLink.click();
    });

    this.setState({ generateQRCodes: false });
  }

  pesquisar(val) {
    const term = val.trim().toLowerCase();
    if (term === "") {
      $(".tableList").fadeIn();
    } else {
      this.state.users.forEach(user => {
        const fullName = `${user.name} ${user.lastName}`.toLowerCase();
        const match =
          fullName.includes(term) ||
          user.email.toLowerCase().includes(term) ||
          user.username.toLowerCase().includes(term);
        const $row = $(`.tableList[idc="${user.id}"]`);
        match ? $row.fadeIn() : $row.fadeOut();
      });
    }
  }

  // Gera relatório APENAS dos usuários selecionados
  generateStudentReport(selectedUsers) {
    if (!Array.isArray(selectedUsers) || selectedUsers.length === 0) {
      this.refs.notificationAlert?.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["atencao"] || "Atenção"}</span>
            <span data-notify="message">
              {this.props.translate["selecione_ao_menos_um_usuario"] || "Selecione ao menos um usuário."}
            </span>
          </div>
        ),
        type: "warning",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      });
      return;
    }

    const list = selectedUsers;
    const headers = [
      this.props.translate["nome"],
      this.props.translate["sobrenome"],
      this.props.translate["sexo"],
      this.props.translate["nascimento"],
      this.props.translate["idade"],
      this.props.translate["status"]
    ];
    let csv = headers.join(";") + "\r\n";
    list.forEach(u => {
      const birthDate = u.birthDate || "";
      const birth = moment(birthDate, "YYYY-MM-DD").format("DD/MM/YYYY");
      const age = birthDate ? moment().diff(moment(birthDate), "years") : "";
      const sexo =
        u.genre === "1" ? this.props.translate["feminino"] : u.genre === "2" ? this.props.translate["masculino"] : "";
      const status = parseInt(u.blocked, 10) === 0 ? this.props.translate["ativo"] : this.props.translate["inativo"];
      csv += [u.name || "", u.lastName || "", sexo, birth, age, status].join(";") + "\r\n";
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "relatorio_alunos.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  confirmGenerateReport() {
    const selected = this.getSelectedUsers();
    if (selected.length === 0) {
      this.refs.notificationAlert.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["atencao"] || "Atenção"}</span>
            <span data-notify="message">
              {this.props.translate["selecione_ao_menos_um_usuario"] || "Selecione ao menos um usuário."}
            </span>
          </div>
        ),
        type: "warning",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      });
      return;
    }

    Swal.fire({
      title: `${this.props.translate["deseja_gerar_relatorio_de"]} ${selected.length} ${this.props.translate["alunos_da_unidade"]} ${this.state.companyName}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: `<i class="fas fa-check"></i> ${this.props.translate["sim"]}`,
      cancelButtonText: `<i class="fas fa-times"></i> ${this.props.translate["nao"]}`
    }).then(result => {
      if (result.isConfirmed) {
        this.generateStudentReport(selected);
      }
    });
  }

  escapeCsvValue(val) {
    if (val === undefined || val === null) return "";
    const s = String(val).trim();
    if (s.indexOf(",") !== -1 || s.indexOf('"') !== -1 || s.indexOf("\n") !== -1) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  }

  async exportAlunos() {
    const companyId = this.props.user.preference.selectcompany;
    if (!companyId) {
      this.refs.notificationAlert?.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["atencao"] || "Atenção"}</span>
            <span data-notify="message">{this.props.translate["selecione_uma_unidade"] || "Selecione uma unidade."}</span>
          </div>
        ),
        type: "warning",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      });
      return;
    }
    this.setState({ exportAlunosLoading: true });
    try {
      const res = await api.getCompanyUsersExport(companyId);
      const list = Array.isArray(res.data) ? res.data : [];
      const headers = ["ID", "Email", "Username", "Nome", "Sobrenome", "Senha", "Bloqueado", "Bloqueio QR", "Motivo bloqueio", "Turmas (nomes separados por vírgula)"];
      let csv = headers.map(h => this.escapeCsvValue(h)).join(",") + "\r\n";
      list.forEach(u => {
        const blocked = parseInt(u.blocked, 10) === 1 ? "sim" : "não";
        const blockedQR = parseInt(u.blockedQRcode, 10) === 1 ? "sim" : "não";
        const turmas = (u.classRooms || []).map(c => (c && c.name) || "").filter(Boolean).join("; ");
        const row = [
          u.id,
          u.email || "",
          u.username || "",
          u.name || "",
          u.lastName || "",
          "",
          blocked,
          blockedQR,
          u.blockedReason || "",
          turmas
        ];
        csv += row.map(cell => this.escapeCsvValue(cell)).join(",") + "\r\n";
      });
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "alunos_unidade_" + moment().format("YYYYMMDD") + ".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (err) {
      let msg = this.props.translate["erro_ao_exportar"] || "Erro ao exportar.";
      if (err.response && err.response.data) {
        if (typeof err.response.data === "string") msg = err.response.data;
        else if (err.response.data.msg) msg = err.response.data.msg;
      } else if (err.message) msg = err.message;
      this.refs.notificationAlert?.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["ops"] || "Ops"}</span>
            <span data-notify="message">{msg}</span>
          </div>
        ),
        type: "danger",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      });
    } finally {
      this.setState({ exportAlunosLoading: false });
    }
  }

  toggleShowBlocked() {
    this.setState(prev => {
      const showBlocked = !prev.showBlocked;
      return {
        showBlocked,
        filteredUsers: showBlocked
          ? prev.users
          : prev.users.filter(u => parseInt(u.blocked, 10) === 0)
      };
    });
  }

  normalizarParaLogin(str) {
    if (!str || typeof str !== "string") return "";
    const map = { á: "a", à: "a", ã: "a", â: "a", é: "e", ê: "e", í: "i", ó: "o", ô: "o", õ: "o", ú: "u", ç: "c" };
    let s = str.toLowerCase().trim();
    Object.keys(map).forEach(k => { s = s.replace(new RegExp(k, "g"), map[k]); });
    s = s.replace(/[^a-z0-9._-]/g, "");
    return s;
  }

  getPadronizarUsername(user, pattern, alreadyUsed) {
    if (pattern === "manter") return user.username || "";
    const nome = this.normalizarParaLogin((user.name || "").trim());
    const sobrenome = this.normalizarParaLogin((user.lastName || "").trim());
    let base = "";
    if (pattern === "nome.sobrenome") base = sobrenome ? `${nome}.${sobrenome}` : nome;
    else if (pattern === "nome_sobrenome") base = sobrenome ? `${nome}_${sobrenome}` : nome;
    else if (pattern === "sobrenome.nome") base = nome ? `${sobrenome}.${nome}` : sobrenome;
    else return user.username || "";
    if (!base) return user.username || "";
    let candidate = base;
    let n = 1;
    while (alreadyUsed.has(candidate)) {
      candidate = base + (n > 1 ? n : "");
      n++;
    }
    alreadyUsed.add(candidate);
    return candidate;
  }

  getPadronizarPassword(user, option, fixedValue) {
    if (option === "manter") return null;
    if (option === "mesma" && fixedValue) return fixedValue;
    if (option === "data_nascimento" && user.birthDate) {
      return moment(user.birthDate, "YYYY-MM-DD").format("DDMMYYYY");
    }
    if (option === "default") return "Senha123!";
    return null;
  }

  openPadronizarModal() {
    this.setState({
      openPadronizarModal: true,
      padronizarError: "",
      padronizarProgress: null,
      padronizarPasswordFixa: ""
    });
  }

  closePadronizarModal() {
    this.setState({
      openPadronizarModal: false,
      padronizarProgress: null,
      padronizarError: ""
    });
  }

  async executarPadronizacao() {
    const selected = this.getSelectedUsers();
    if (!selected.length) {
      this.refs.notificationAlert.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title">{this.props.translate["atencao"] || "Atenção"}</span>
            <span data-notify="message">{this.props.translate["selecione_ao_menos_um_usuario"] || "Selecione ao menos um usuário."}</span>
          </div>
        ),
        type: "warning",
        icon: "ni ni-bell-55",
        autoDismiss: 7
      });
      return;
    }

    const { padronizarUsernamePattern, padronizarPasswordOption, padronizarPasswordFixa } = this.state;
    if (padronizarPasswordOption === "mesma" && !padronizarPasswordFixa.trim()) {
      this.setState({ padronizarError: "Informe a senha quando usar \"Mesma para todos\"." });
      return;
    }

    this.setState({ padronizarError: "", padronizarProgress: { current: 0, total: selected.length, ok: 0, err: 0 } });
    const usedUsernames = new Set();
    let ok = 0;
    let err = 0;

    for (let i = 0; i < selected.length; i++) {
      const user = selected[i];
      this.setState(prev => ({
        padronizarProgress: { ...prev.padronizarProgress, current: i + 1 }
      }));

      try {
        if (padronizarUsernamePattern !== "manter") {
          const newUsername = this.getPadronizarUsername(user, padronizarUsernamePattern, usedUsernames);
          if (newUsername && newUsername !== user.username) {
            await api.updateUser(user.id, { username: newUsername });
            const users = [...this.state.users].map(u =>
              parseInt(u.id) === parseInt(user.id) ? { ...u, username: newUsername } : u
            );
            this.setState({ users });
          }
        }

        const newPassword = this.getPadronizarPassword(user, padronizarPasswordOption, padronizarPasswordFixa);
        if (newPassword) {
          await api.changeUserPassword(user.id, { password: newPassword, confirmPassword: newPassword });
        }
        ok++;
      } catch (e) {
        err++;
        console.error("Padronizar usuário", user.id, e);
      }
    }

    this.setState(prev => ({
      padronizarProgress: prev.padronizarProgress ? { ...prev.padronizarProgress, ok, err, done: true } : null
    }));

    this.refs.notificationAlert.notificationAlert({
      place: "tr",
      message: (
        <div className="alert-text">
          <span className="alert-title">{this.props.translate["sucesso"] || "Sucesso"}!</span>
          <span data-notify="message">
            Padronização concluída: {ok} atualizado(s){err > 0 ? `, ${err} erro(s).` : "."}
          </span>
        </div>
      ),
      type: err > 0 ? "warning" : "success",
      icon: "ni ni-check-bold",
      autoDismiss: 7
    });
    if (this.state.showBlocked === false) {
      const filteredUsers = this.state.users.filter(u => parseInt(u.blocked, 10) === 0);
      this.setState({ filteredUsers });
    }
    this.getAllUsers();
  }

  render() {
    const {
      filteredUsers,
      showRest,
      showBlocked,
      userClassrooms,
      classroomModalOpen,
      classroomModalUserId
    } = this.state;

    const paginated = filteredUsers;
    var countChecks = $(".user_check:checked").length;
    var showButtosExtra = countChecks > 0;

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>

        <SimpleHeader
          name={this.props.translate["usuarios"]}
          way={[{ name: this.props.translate["usuarios"], url: "/users" }]}
        />
        <Container className="mt--6" fluid>
          <Card>
            <CardHeader className="border-0">
              <Row className="align-items-center">
                <Col xs="12" md="auto" className="mb-3 mb-md-0">
                  <h3 className="mb-0">
                    {this.props.translate["lista_de_usuarios"]}
                    {this.state.loadUser && this.state.users.length > 0 && (
                      <span className="ml-2 text-muted" style={{ fontSize: "1rem" }}>
                        ({paginated.length})
                      </span>
                    )}
                  </h3>
                </Col>
                <Col xs="12" md className="d-flex flex-wrap justify-content-md-end align-items-center" style={{ gap: "0.5rem" }}>
                  {showButtosExtra && (
                    <>
                      <Button
                        className="btn-round btn-icon"
                        color="default"
                        onClick={() => this.generateQr()}
                        size="sm"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-qrcode" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["gerar_qr_code"]}
                          {this.state.generateQRCodes && (
                            <font style={{ marginLeft: "4px" }}>
                              <ClipLoader sizeUnit={"px"} size={10} color={"#ffffff"} loading={true} />{" "}
                              {this.state.qrcodeprogress}%{" "}
                            </font>
                          )}
                        </span>
                      </Button>

                      <Button
                        className="btn-round btn-icon"
                        color="info"
                        onClick={this.openPadronizarModal}
                        size="sm"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-user-cog" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["padronizar_usuarios"] || "Padronizar usuários"}
                        </span>
                      </Button>
                    </>
                  )}

                  {this.props.permission.indexOf(33) !== -1 && (
                    <>
                      <Button
                        className="btn-round btn-icon"
                        color="success"
                        onClick={() => this.newImport()}
                        size="sm"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="far fa-file-excel" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["importar_planilha"]}
                        </span>
                      </Button>

                      <Button
                        className="btn-round btn-icon"
                        color="success"
                        onClick={() => this.openBulkUpdateModal()}
                        size="sm"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-edit" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["atualizar_por_planilha"] || "Atualizar por planilha"}
                        </span>
                      </Button>

                      <Button
                        className="btn-round btn-icon"
                        color="primary"
                        size="sm"
                        onClick={() => this.exportAlunos()}
                        disabled={!showButtosExtra || this.state.exportAlunosLoading}
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-file-export" />
                        </span>
                        <span className="btn-inner--text">
                          {this.state.exportAlunosLoading ? (this.props.translate["exportando"] || "Exportando...") : (this.props.translate["exportar_alunos"] || "Exportar alunos")}
                        </span>
                      </Button>

                      <Button
                        className="btn-round btn-icon"
                        color="success"
                        size="sm"
                        onClick={() => this.confirmGenerateReport()}
                        disabled={!showButtosExtra}
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="far fa-file-excel" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["relatorio_de_alunos"]}
                        </span>
                      </Button>

                      <Button
                        className="btn-neutral btn-round btn-icon"
                        color="default"
                        onClick={() => this.newUser()}
                        size="sm"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-user-plus" />
                        </span>
                        <span className="btn-inner--text">
                          {this.props.translate["criar_usuario"]}
                        </span>
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </CardHeader>

            <div
              style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
              id="datatable-basic_filter"
              className="dataTables_filter px-4 pb-1"
            >
              <label style={{ marginRight: "10px" }}>
                {this.props.translate["procurar"]}:
                <input
                  type="text"
                  className="form-control form-control-sm"
                  onChange={event => this.pesquisar(event.target.value)}
                />
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <input
                    checked={this.state.showRest}
                    onChange={e => {
                      this.setState({ showRest: e.target.checked });
                    }}
                    type="checkbox"
                    className="form-control"
                  />
                </div>
                <div style={{ marginLeft: "10px" }}>
                  {this.props.translate["mostrar_outras_informacoes"]}
                </div>
              </div>

              {/* Botão “Ver Bloqueados Também” / “Ocultar Bloqueados” */}
              <Button
                color="primary"
                size="sm"
                className="ml-auto"
                onClick={this.toggleShowBlocked}
              >
                <span className="btn-inner--icon mr-1">
                  {showBlocked ? (
                    <i className="fas fa-user-check" />
                  ) : (
                    <i className="fas fa-user-lock" />
                  )}
                </span>
                <span className="btn-inner--text">
                  {showBlocked
                    ? this.props.translate["ver_apenas_usuarios_ativos"]
                    : this.props.translate["ver_usuarios_bloqueados_tambem"]}
                </span>
              </Button>
            </div>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th
                    style={{
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      width: "1px"
                    }}
                  >
                    <center>
                      <div
                        className="custom-control custom-checkbox"
                        style={{ width: "28px", paddingLeft: "58px", paddingRight: "0px" }}
                      >
                        <input
                          onChange={() => this.checkAll()}
                          className="custom-control-input user_check_all"
                          id={"_check"}
                          type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor={"_check"}></label>
                      </div>
                    </center>
                  </th>
                  <th>id</th>
                  <th>{this.props.translate["nome"]}</th>
                  <th>{this.props.translate["usuario"]}</th>
                  <th>{this.props.translate["email"]}</th>
                  <th hidden={!this.state.showRest}>{this.props.translate["criado_em"]}</th>
                  <th hidden={!this.state.showRest}>{this.props.translate["editado_em"]}</th>
                  <th>
                    <center>{this.props.translate["acesso_bloqueado"]}</center>
                  </th>
                  <th hidden={!this.state.showRest}>
                    <center>{this.props.translate["qr_code_bloqueado"]}</center>
                  </th>
                  <th hidden>{this.props.translate["data_de_nascimento"]}</th>
                  <th>{this.props.translate["nivel_de_acesso"]}</th>
                  <th hidden={!this.state.showRest}>{this.props.translate["ultimo_editor"]}</th>
                  <th hidden={!this.state.showRest}>
                    <center>{this.props.translate["turmas"]}</center>
                  </th>
                  <th>{this.props.translate["acoes"]}</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((value, index) => {
                  let accessLevel, b, c;
                  const key = "user_key_" + value.id;
                  const tooltip = "tooltip_user_key_" + value.id;
                  const tooltip2 = "tooltip2_user_key_" + value.id;

                  if (parseInt(value.blocked) === 1) {
                    b = <strong style={{ color: "red" }}>{this.props.translate["sim"]}</strong>;
                  } else {
                    b = <strong style={{ color: "green" }}>{this.props.translate["nao"]}</strong>;
                  }

                  if (parseInt(value.blockedQRcode) === 1) {
                    c = <strong style={{ color: "red" }}>{this.props.translate["sim"]}</strong>;
                  } else {
                    c = <strong style={{ color: "green" }}>{this.props.translate["nao"]}</strong>;
                  }

                  this.state.levelAcess.forEach(item => {
                    if (parseInt(item.id) === parseInt(value.accessLevel)) {
                      accessLevel = item.name;
                    }
                  });

                  const createDateFormatted = moment(
                    value.createDate,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("DD/MM/YYYY HH:mm:ss");
                  const updateDateFormatted = moment(
                    value.updateDate,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("DD/MM/YYYY HH:mm:ss");

                  const classes = userClassrooms[value.id] || [];

                  return (
                    <tr key={key} idc={value.id} className="tableList">
                      <td
                        style={{
                          paddingLeft: "0px",
                          paddingRight: "0px",
                          width: "28px"
                        }}
                      >
                        <center>
                          <div
                            className="custom-control custom-checkbox"
                            style={{ width: "28px", paddingLeft: "58px", paddingRight: "0px" }}
                          >
                            <input
                              idc={value.id}
                              onClick={() => this.checkUser()}
                              className="custom-control-input user_check"
                              id={key + "user_check"}
                              type="checkbox"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={key + "user_check"}
                            ></label>
                          </div>
                        </center>
                      </td>
                      <td>{value.id}</td>
                      <td className="table-user">
                        <img
                          alt="..."
                          className="avatar rounded-circle mr-3 photo_user"
                          idc={value.id}
                          src={value.photo}
                        />
                        <b>
                          {value.name} {value.lastName}
                        </b>
                      </td>
                      <td>{value.username}</td>
                      <td>{value.email}</td>
                      <td hidden={!this.state.showRest}>{createDateFormatted}</td>
                      <td hidden={!this.state.showRest}>{updateDateFormatted}</td>
                      <td>
                        <center>{b}</center>
                      </td>
                      <td hidden={!this.state.showRest}>
                        <center>{c}</center>
                      </td>
                      <td hidden>
                        {moment(value.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
                      </td>
                      <td>{accessLevel}</td>
                      <td hidden={!this.state.showRest}>
                        {parseInt(value.edit_count) > 0 ? (
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              this.setState({
                                openUserEditHistory: true,
                                userEditHistoryId: value.id,
                                userEditHistoryName: `${value.name} ${value.lastName}`
                              });
                            }}
                            className="badge badge-primary"
                            style={{ cursor: "pointer" }}
                          >
                            {value.last_editor || this.props.translate["editor_desconhecido"]}
                          </a>
                        ) : (
                          <span className="text-muted">{this.props.translate["nunca_editado"]}</span>
                        )}
                      </td>
                      <td hidden={!this.state.showRest}>
                        <Button
                          color="link"
                          size="sm"
                          onClick={() => this.openClassroomModal(value.id)}
                        >
                          {this.props.translate["ver_turmas"]}
                        </Button>
                      </td>
                      <td className="table-actions">
                        <a
                          href="#"
                          onClick={() => this.openCourseHistory(value.id)}
                          className="table-action"
                          id={`tooltip_history_${value.id}`}
                        >
                          <i className="fas fa-history" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target={`tooltip_history_${value.id}`}
                        >
                          {this.props.translate["historico_de_cursos"]}
                        </UncontrolledTooltip>

                        {this.props.permission.indexOf(1) !== 33 && (
                          <React.Fragment>
                            <a
                              onClick={() => this.editUser(value.id)}
                              className="table-action"
                              href="#pablo"
                              id={tooltip}
                            >
                              <i className="fas fa-user-edit" />
                            </a>
                            <UncontrolledTooltip delay={0} target={tooltip}>
                              {this.props.translate["editar_usuario"]}
                            </UncontrolledTooltip>
                          </React.Fragment>
                        )}

                        {this.props.permission.indexOf(32) !== -1 && (
                          <React.Fragment>
                            <a
                              onClick={() => this.editQRcodeUser(value.id)}
                              className="table-action"
                              href="#pablo"
                              id={tooltip + "qr_code"}
                            >
                              <i className="fas fa-qrcode" />
                            </a>
                            <UncontrolledTooltip delay={0} target={tooltip + "qr_code"}>
                              {this.props.translate["configurar_qr_code"]}
                            </UncontrolledTooltip>
                          </React.Fragment>
                        )}

                        {this.props.permission.indexOf(31) !== -1 && (
                          <React.Fragment>
                            <a
                              onClick={() =>
                                this.props.setState({ userPhoto: value.id, openModalChangePhoto: true })
                              }
                              className="table-action"
                              href="#pablo"
                              id={tooltip + "qr_photo"}
                            >
                              <i className="far fa-image"></i>
                            </a>
                            <UncontrolledTooltip delay={0} target={tooltip + "qr_photo"}>
                              {this.props.translate["alterar_foto"]}
                            </UncontrolledTooltip>
                          </React.Fragment>
                        )}

                        {this.props.permission.indexOf(30) !== -1 && (
                          <React.Fragment>
                            <a
                              onClick={() =>
                                this.setState({ alterUserPassword: value.id, openModalalterUserPassword: true })
                              }
                              className="table-action"
                              href="#pablo"
                              id={tooltip + "qr_photoss"}
                            >
                              <i className="fas fa-key"></i>
                            </a>
                            <UncontrolledTooltip delay={0} target={tooltip + "qr_photoss"}>
                              {this.props.translate["alterar_senha"]}
                            </UncontrolledTooltip>
                          </React.Fragment>
                        )}

                        {parseInt(value.id) !== parseInt(window.app.state.user.id) &&
                          this.props.permission.indexOf(34) !== -1 && (
                            <React.Fragment>
                              <a
                                onClick={() => this.removerUser(value.id)}
                                className="table-action table-action-delete"
                                href="#pablo"
                                id={tooltip2}
                              >
                                <i className="fas fa-trash" />
                              </a>
                              <UncontrolledTooltip delay={0} target={tooltip2}>
                                {this.props.translate["deletar_usuario"]}
                              </UncontrolledTooltip>
                            </React.Fragment>
                          )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {/* Loader enquanto carrega */}
            {!this.state.loadUser && this.props.user.preference.selectcompany !== "" && (
              <React.Fragment>
                <div className="col-md-12" style={{ marginTop: "40px", marginBottom: "30px" }}>
                  <center>
                    <ClipLoader sizeUnit={"px"} size={60} color={"#adb5bd"} loading={true} />
                  </center>
                </div>
              </React.Fragment>
            )}

            {/* Quando não houver usuários */}
            {this.state.users.length === 0 &&
              this.props.user.preference.selectcompany !== "" &&
              this.state.loadUser && (
                <React.Fragment>
                  <center>
                    <h3 style={{ margin: "30px 0px" }}>
                      {this.props.translate["nenhum_usuario_foi_encontrado"]}
                    </h3>
                  </center>
                </React.Fragment>
              )}

            {/* Quando não existe companhia selecionada */}
            {this.props.user.preference.selectcompany === "" && (
              <React.Fragment>
                <center>
                  <h3 style={{ margin: "30px 0px" }}>
                    {this.props.translate["voce_nao_tem_acesso_a_nenhum_unidade"]}
                  </h3>
                </center>
              </React.Fragment>
            )}

            <div className="d-flex justify-content-between align-items-center mt-3 px-3 p-3">
              <small>
                {this.props.translate["mostrando"]} {paginated.length} {this.props.translate["de"]} {filteredUsers.length} {this.props.translate["usuarios"]}
              </small>
            </div>
          </Card>
        </Container>

        <EditUserQRcode
          state={this.state}
          setState={e => this.setState(e)}
          handleQrScan={this.handleQrScan}
          handleQrError={this.handleQrError}
        />
        <EditUser saveUser={e => this.saveUser(e)} state={this.state} setState={e => this.setState(e)} />
        <EditUserCardQRCode state={this.state} setState={e => this.setState(e)} />
        <ImportXlsxUser
          getAllUsers={this.getAllUsers}
          state={this.state}
          setState={e => this.setState(e)}
          postUser={this.postUser}
        />
        <BulkUpdateUsersXlsx
          getAllUsers={this.getAllUsers}
          state={this.state}
          setState={e => this.setState(e)}
        />
        <SmartExcelConverter
          isOpen={this.state.openSmartConverter}
          onClose={() => this.setState({ openSmartConverter: false, openModalImport: true })}
          state={this.state}
        />
        <AlterUserPassword state={this.state} setState={data => this.setState(data)} />
        <UserLogs state={this.state} setState={e => this.setState(e)} />
        <UserEditHistory
          isOpen={this.state.openUserEditHistory}
          userId={this.state.userEditHistoryId}
          userName={this.state.userEditHistoryName}
          toggle={() => this.setState({ openUserEditHistory: false })}
        />
        <ModalUserClassrooms
          isOpen={classroomModalOpen}
          toggle={() => this.closeClassroomModal()}
          userClassrooms={userClassrooms[classroomModalUserId] || []}
          userName={
            this.state.users.find(u => u.id === classroomModalUserId)?.name || this.props.translate["usuario"]
          }
        />

        <CourseHistoryModal
          isOpen={this.state.openCourseHistory}
          toggle={() => this.closeCourseHistory()}
          userName={this.state.courseHistoryUserName}
          userId={this.state.courseHistoryUserId}
          history={this.state.courseHistory}
        />

        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.openPadronizarModal}
          toggle={this.closePadronizarModal}
        >
          <div className="modal-header">
            <h6 className="modal-title">
              {this.props.translate["padronizar_usuarios"] || "Padronizar usuários em massa"}
            </h6>
            <button
              aria-label="Close"
              className="close"
              type="button"
              onClick={this.closePadronizarModal}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <p className="text-muted small mb-3">
              Aplica novo padrão de <strong>nome de usuário</strong> e/ou <strong>senha</strong> apenas nos usuários selecionados na lista ({this.getSelectedUserIds().length} selecionado(s)).
            </p>

            <FormGroup>
              <label>{this.props.translate["nome_de_usuario"] || "Nome de usuário"}</label>
              <Input
                type="select"
                value={this.state.padronizarUsernamePattern}
                onChange={e => this.setState({ padronizarUsernamePattern: e.target.value })}
              >
                <option value="manter">Manter como está</option>
                <option value="nome.sobrenome">nome.sobrenome (ex: joao.silva)</option>
                <option value="nome_sobrenome">nome_sobrenome (ex: joao_silva)</option>
                <option value="sobrenome.nome">sobrenome.nome (ex: silva.joao)</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <label>{this.props.translate["senha"] || "Senha"}</label>
              <Input
                type="select"
                value={this.state.padronizarPasswordOption}
                onChange={e => this.setState({ padronizarPasswordOption: e.target.value, padronizarError: "" })}
              >
                <option value="manter">Manter como está</option>
                <option value="data_nascimento">Data de nascimento (DDMMAAAA)</option>
                <option value="default">Padrão: Senha123!</option>
                <option value="mesma">Mesma para todos (informe abaixo)</option>
              </Input>
            </FormGroup>

            {this.state.padronizarPasswordOption === "mesma" && (
              <FormGroup>
                <label>Senha para todos</label>
                <Input
                  type="password"
                  placeholder="Digite a senha"
                  value={this.state.padronizarPasswordFixa}
                  onChange={e => this.setState({ padronizarPasswordFixa: e.target.value, padronizarError: "" })}
                />
              </FormGroup>
            )}

            {this.state.padronizarError && (
              <div className="alert alert-danger py-2 mb-2">{this.state.padronizarError}</div>
            )}

            {this.state.padronizarProgress && (
              <div className="alert alert-info py-2 mb-2">
                Processando: {this.state.padronizarProgress.current} / {this.state.padronizarProgress.total}
                {this.state.padronizarProgress.ok !== undefined && (
                  <span className="ml-2">— OK: {this.state.padronizarProgress.ok}, erros: {this.state.padronizarProgress.err}</span>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <Button color="secondary" onClick={this.closePadronizarModal}>
              {this.props.translate["cancelar"] || "Cancelar"}
            </Button>
            <Button
              color="primary"
              onClick={this.executarPadronizacao}
              disabled={this.state.padronizarProgress && !this.state.padronizarProgress.done}
            >
              {this.state.padronizarProgress && !this.state.padronizarProgress.done
                ? "Aplicando…"
                : (this.props.translate["aplicar"] || "Aplicar")}
            </Button>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-danger"
          contentClassName="bg-gradient-danger"
          isOpen={this.state.openDialogRemoveUser}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-notification">
              {this.props.translate["sua_atencao_e_requirida"]}.
            </h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.setState({ openDialogRemoveUser: false })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className="fas fa-exclamation-triangle fa-x3" style={{ fontSize: "45px" }}></i>
              <h4 className="heading mt-4">{this.props.translate["voce_deve_ler_isto"]}!</h4>
              <p dangerouslySetInnerHTML={{ __html: this.props.translate["atencao_remover_usuario"] }} />
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="btn-white"
              color="default"
              type="button"
              onClick={() => this.removeUserApi()
              }
            >
              {this.props.translate["ok_remova"]}
            </Button>
            <Button
              className="text-white ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={() => this.setState({ openDialogRemoveUser: false })}
            >
              {this.props.translate["cancelar_e_fechar"]}
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user
}))(Users);
